import React from 'react';
import { useI18n } from '../../../../../i18n';
import Menu from '../../../general/menu/Menu';
import iconMap from '../../../../img/icons/map.png'
import { className } from '../../../../lib/className';

/**
 * @param {Object} props
 * @param {function} props.onClick
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.active]
 */
function SwitchMapMenuItem(props) {
	const { fc } = useI18n();

	return (
		<Menu.Item className={className({ active: props.active })} onClick={props.onClick} disabled={props.disabled}>
			<img src={iconMap} alt="" title={props.active ? fc('hide map') : fc('show map')} />
		</Menu.Item>
	);
}

export default SwitchMapMenuItem;